import getConfigDetails  from '../services/config'
import { getFormattedAmountNumber } from '../utils/helper'

export const EMPTY_ARRAY = Object.freeze([])
export const EMPTY_OBJECT = Object.freeze({})

// facility_payment_details.facility_payment_type_id values from the API: compare against these, never a number
export const PAYMENT_GATEWAY = {
	DATATRANS: '1',
	DATACAP: '2',
	FISERV: '3',
	HEARTLAND: '4',
	STRIPE: '6'
}

// The card is entered in the gateway's own hosted fields, which have their own Submit:
// Stripe always; Datacap / Heartland only when is_iframe_enabled is '1' (no configuration = card form, as PaymentGatewayCommon). Fiserv
// (CardConnect) and the plain card form use the screen's Pay button.
export const usesHostedCardFields = (facility) => {
	const type = String(facility?.facility_payment_details?.facility_payment_type_id)
	return type === PAYMENT_GATEWAY.STRIPE
		|| ([PAYMENT_GATEWAY.DATACAP, PAYMENT_GATEWAY.HEARTLAND].includes(type) && facility?.facility_configuration?.is_iframe_enabled == '1')
}

export const formId = 'ipg_form'

export const CURRENCY = {
	usd: 'USD',
	euro: 'EURO',
	inr: 'INR'
}

export const STATUS = {
	active: 'Active',
	inactive: 'Inactive'
}


export const EVENT_TYPES = {
	EVENT: 'event',
	BUNDLE_PASS: 'bundle-pass',
	PARTY_PASS: 'party-pass',
	SIMPLE: 'simple-pass'
}

export const EVENT_TYPES_VALUES = {
	EVENT: 'Single Event',
	BUNDLE_PASS: 'Full Season',
	PARTY_PASS: 'Half Season',
	SIMPLE: '6 Pack'
}


export const EVENT_TYPES_VALUES_LOGS = {
	EVENT: 'SINGLE EVENT',
	BUNDLE_PASS: 'FULL SEASON',
	PARTY_PASS: 'HALF SEASON',
	SIMPLE: '6 PACK'
}

export const DEFAULT_EVENT_RATE = getFormattedAmountNumber('0.00')
export const DEFAULT_IMAGE = 'blank-image'

// export const validEmail = new RegExp('/^[a-zA-Z0-9]+@(?:[a-zA-Z0-9]+.)+[A-Za-z]+$/')
// export const validPhone = new RegExp('^[0-9]{10}$')
export const validPhone = /^(?!.(\d)\1{5,})(?!.(\d{2})\2{2,})\d{10}$/



export const MONTH_NAMES = [
	'Jan',
	'Feb',
	'Mar',
	'Apr',
	'May',
	'Jun',
	'Jul',
	'Aug',
	'Sep',
	'Oct',
	'Nov',
	'Dec',
]
export const DAYS = [
	'Sunday',
	'Monday',
	'Tuesday',
	'Wednesday',
	'Thursday',
	'Friday',
	'Saturday',
]
export const EXPIRY_MONTHS = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']

const expYear = () => {
	let yearsVal = []
	for (let i = 0; i <= 26; i++) {
		let fullYear = new Date().getFullYear() + i
		yearsVal.push({
			val: fullYear % 100,
			label: fullYear
		})
	}
	return yearsVal
}

export const EXPIRY_YEARS = expYear()
// export const EXPIRY_YEARS = [
// 	{
// 		val: '24',
// 		label: new Date().getFullYear()
// 	},
// 	{
// 		val: '25',
// 		label: '2025'
// 	},
// 	{
// 		val: '26',
// 		label: '2026'
// 	},
// 	{
// 		val: '27',
// 		label: '2027'
// 	},
// 	{
// 		val: '28',
// 		label: '2028'
// 	},
// 	{
// 		val: '29',
// 		label: '2029'
// 	},
// 	{
// 		val: '30',
// 		label: '2030'
// 	},
// 	{
// 		val: '31',
// 		label: '2031'
// 	},
// 	{
// 		val: '32',
// 		label: '2032'
// 	},
// 	{
// 		val: '33',
// 		label: '2033'
// 	},
// 	{
// 		val: '34',
// 		label: '2034'
// 	},
// 	{
// 		val: '35',
// 		label: '2035'
// 	},
// 	{
// 		val: '36',
// 		label: '2036'
// 	},
// 	{
// 		val: '37',
// 		label: '2037'
// 	},
// 	{
// 		val: '38',
// 		label: '2038'
// 	},
// 	{
// 		val: '39',
// 		label: '2039'
// 	},
// 	{
// 		val: '40',
// 		label: '2040'
// 	},
// 	{
// 		val: '41',
// 		label: '2041'
// 	},
// 	{
// 		val: '42',
// 		label: '2042'
// 	},
// 	{
// 		val: '43',
// 		label: '2043'
// 	},
// 	{
// 		val: '44',
// 		label: '2044'
// 	},
// 	{
// 		val: '45',
// 		label: '2045'
// 	},
// 	{
// 		val: '46',
// 		label: '2046'
// 	},
// 	{
// 		val: '47',
// 		label: '2047'
// 	},
// 	{
// 		val: '48',
// 		label: '2048'
// 	},
// 	{
// 		val: '49',
// 		label: '2049'
// 	},
// 	{
// 		val: '50',
// 		label: '2050'
// 	}


// ]

export const MONTHNAME = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December',
]
export const MONTHNAMESMALL = [
	'Jan',
	'Feb',
	'Mar',
	'Apr',
	'May',
	'Jun',
	'Jul',
	'Aug',
	'Sep',
	'Oct',
	'Nov',
	'Dec',
]
export const WEEKDAYS = [
	'Sunday',
	'Monday',
	'Tuesday',
	'Wednesday',
	'Thursday',
	'Friday',
	'Saturday',
]

export const CARDTYPES =
{
	VS: 'VS',
	MC: 'MC'
}


export const signupPayload = {
	'firstname': '',
	'lastname': '',
	'email': '',
	'phone': '',
	'address1': '',
	'address2': '',
	'city': '',
	'state': '',
	'zipcode': '',
	'password': '',
	'cpassword': '',
}

export const vehicleArray = [{ 'license_plate': '', 'make_model': '' }]
export const vehicleTableHeader = ['License Plate', 'Make / Modal', 'Status', 'Action']
export const bookingTableHeader = ['Ticket Number', 'License Plate ', 'Check-in Date & Time', 'Amount', 'Vehicle', 'Action']

export const validPassword = new RegExp('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$')

export const userProfilePayload = {
	'email': '',
	'phone': '',
	'license_number': '',
	'address': '',
	'address2': '',
	'city': '',
	'state': '',
	'zipcode': ''
}
export const validEmail = new RegExp('/^[a-zA-Z0-9]+@(?:[a-zA-Z0-9]+.)+[A-Za-z]+$/')
export const validLicenceNumber = new RegExp('^(?=.*[0-9]).{7,13}$')

export const newpasswordValidation = (value) => {
	return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,15}$/.test(value)
}

// export const eventMenu = [
// 	{ name: 'All Event', id: 0, redirectto: '#' },
// 	{ name: 'Group Events', id: 1, redirectto: '#' },
// 	{ name: 'Corporate', id: 2, redirectto: '#' },
// 	{ name: 'Business Event', id: 3, redirectto: '#' },
// 	{ name: 'Public Event', id: 4, redirectto: '#' }
// ]

export const EVENT_LOG_TITLE = {
	HOME: 'LOG - HOME PAGE LOADED',
	BOOK_NOW_SINGLE_EVENT: 'LOG - BOOK NOW - SINGLE EVENT',
	PAYMENT_LOADED: 'LOG - PAYMENT PAGE - LOADED',
	PAYMENT: 'LOG - PAYMENT PAGE - USER AND CARD DETAILS',
	DOWNLOAD_TICKET: 'LOG - DOWNLOAD TICKET - CLICKED',
	RE_DOWNLOAD_TICKET: 'LOG - RE-DOWNLOAD TICKET - CLICKED',
	FINAL_PAGE: 'LOG - RESPONSE PAGE - LOADED',
	SUCCESS: 'LOG - RESPONSE PAGE - PAYMENT SUCCESS',
	PROMO_PAY_SUCCESS: 'LOG - RESPONSE PAGE - 100% OFF WITHOUT PAYMENT BOOKING SUCCESS',
	FAILURE: 'LOG - RESPONSE PAGE - PAYMENT FAILURE',
	RESPONSE_SUCCESS: 'LOG - RESPONSE PAGE - RESPONSE SUCCESS',
	RESPONSE_FAILURE: 'LOG - RESPONSE PAGE - RESPONSE FAILURE'
}
export const event_static_image = 'https://placehold.co/600x400/darkgray/white?text=Image+Not+Found'

export const errorMessages = {
	somethingWentWrong: 'Something went wrong, Please try again!',
	expectedError: 'An unexpected error occurred, Please try again!',
	apiBlockedError1: 'NetworkError when attempting to fetch resource.',
	apiBlockedError2: 'TypeError: NetworkError when attempting to fetch resource.',
	soldOutError: 'Sorry, this event is now Sold Out.',
	eventSessionExpired: 'Event session expired, please reload the page.'
}

export const getWalletScriptUrl = (gateway) => {
	let scriptUrl = {
		applePayScript: null,
		googlePayScript: null,
		payButtonScript: null
	}
	switch (String(gateway)) {
		case '1': //Datatrans
			scriptUrl = {
				applePayScript: getConfigDetails?.applePayDTScript,
				googlePayScript: getConfigDetails?.googlePayDTScript,
				payButtonScript: getConfigDetails?.payButtonDTScript
			}
			break
		case '2': //DataCap
			scriptUrl = {
				applePayScript: getConfigDetails?.applePayScript,
				googlePayScript: getConfigDetails?.googlePayScript,
				payButtonScript: getConfigDetails?.payButtonScript,
				// Datacap hosted card fields (DatacapHostedWebToken)
				gatewayIframe: getConfigDetails?.DCIframe
			}
			break
		case '4': //HeartLand
			scriptUrl = {
				applePayScript: getConfigDetails?.applePayHLScript,
				googlePayScript: getConfigDetails?.googlePayHLScript,
				payButtonScript: getConfigDetails?.payButtonHLScript,
				// Heartland SecureSubmit (iframe card fields); without it window.Heartland never exists
				gatewayIframe: getConfigDetails?.HLIframe
			}
			break
		default:
			scriptUrl = {
				applePayScript: null,
				googlePayScript: null,
				payButtonScript: null
			}
			break
	}
    return scriptUrl
}